module.exports = __webpack_public_path__ + "img/xbox.87f3cb80.svg";